import { handleApiError } from '../../../Style';
import axiosInstance from '../../instance/AxiosInstance';

export const addAirportEffect = (airportData) => {
  return axiosInstance
    .post('/airports/insertairport', airportData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response?.data || { message: 'Failed to add airport' };
    });
};

export const airportViewAllEffect = async () => {
  try {
    const response = await axiosInstance.get(`/airports/list`);

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch airport';
  }
};

export const fetchAirportsEffect = (action) => {
  return axiosInstance
    .get(
      `/airports/list?pagination_required=true&page=${action.page}&pageSize=${action.pageSize}`
    )
    .then((response) => {
      console.log('Response data:', response.data); // Log the response data to verify
      return response.data;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Error fetching airports';
      throw new Error(message);
    });
};

export const deleteAirportEffect = (airportId) => {
  return axiosInstance
    .delete(`/airports/deleteairport/${airportId}`)
    .then((response) => {
      console.log('Delete Response:', response); // Log the response
      return response.data; // Return the response
    })
    .catch((error) => {
      throw error.response?.data || { message: 'Failed to delete airport' };
    });
};
export const updateAirportEffect = (airportId, airportData) => {
  return axiosInstance
    .put(`/airports/updateairport/${airportId}`, airportData)
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || { message: 'Failed to update airport' };
    });
};
export const approveAirportEffect = async (payload) => {
  const { airport_id, staff_approve_status } = payload?.payload;
  try {
    const response = await axiosInstance.put(
      `/airports/approveairportupdate?airport_id=${airport_id}`,
      { staff_approve_status: staff_approve_status }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || 'Failed to Approve Airport';
  }
};

export const airportViewEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `airports/getairport?airport_id=${payload}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error) || 'Failed to Fetch Service';
  }
};
